import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import { map, startWith } from "rxjs/operators";
import {
  Combo2Service,
  CommonService,
  ReportService,
} from "../../../../services/index";

@Component({
  selector: "mrpSalesOrderReport",
  templateUrl: "./mrpSalesOrderReport.html",
})
export class mrpSalesOrderReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  gridOptions: any;
  dataList = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  brandList = ["EXPOSE", "ARAZA", "GREEN OLIVE", "LEO BOYS", "JOB", "ALL"];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  filter: any = {
    type: "",
    groupby: "monthwise",
    finyear: "",
    season: 0,
    brand : "EXPOSE"
  };
  @ViewChild("filterPanel") filterPanel;

  seasonControl: FormControl = new FormControl();
  columns = [];
  orderList: any = [];
  seasonList: any = [];
  seasonOption: any;
  constructor(
    public datePipe: DatePipe,
    private common: CommonService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();

    
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    
    let that = this;
    this.seasonOption = this.seasonControl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        return that.seasonList.filter((res) =>
          res.season_name.toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }

  applyFilter(): void {
    
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.getReport();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      var temp = ["Core", "All"];
      that.finyearList.concat(temp);
      that.filter.finyear = that.finyearList[0].finyear;
      that.getReport();
      
    });
  }

  getReport(): void {
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    this.isLoadMask = this.reportService
      .getMRPSOReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }
      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }
  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/MrpSOReport/mrpSalesOrderReport.ts